import React from 'react';
import type { AgentIconProps } from './AgentIconBase';

export default function MLUWAgent({
  width = '100%',
  height = '100%',
  className = '',
}: AgentIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 150 150"
      width={width}
      height={height}
      className={className}
    >
      <circle fill="#0057a8" cx="75" cy="75" r="75" />
      <path
        fill="#fff"
        d="M113.45,51.51c-.1-1.71-1.41-2.84-3.25-2.8-8.12.16-15.7-1.35-23.07-4.5-3.97-1.7-7.3-4.07-10.96-6.47-.88-.58-2.51.06-3.28.63-9.72,7.21-21.21,10.46-33.72,10.34-1.21-.01-2.48,1.02-2.56,2.23-1.89,28.38,6.9,52.67,32.68,68.71,1.98,1.23,3.73,2.29,6.15,2.86,28.94-15.37,39.8-40.59,38.01-70.99ZM94.97,56.85c3.49,0,6.31,2.92,6.31,6.53s-2.83,6.53-6.31,6.53-6.31-2.92-6.31-6.53,2.83-6.53,6.31-6.53ZM74.96,56.48c5.07,0,9.19,4.25,9.19,9.5s-4.11,9.5-9.19,9.5-9.19-4.25-9.19-9.5,4.11-9.5,9.19-9.5ZM54.97,56.85c3.48,0,6.31,2.92,6.31,6.53s-2.83,6.53-6.31,6.53-6.31-2.92-6.31-6.53,2.83-6.53,6.31-6.53ZM44.01,82.99c-.54-6.53,4.69-11.13,10.75-10.63,3.76-.27,7.43.87,9.68,4.48-2.76,1.76-4.89,3.82-6.72,6.16h-13.71ZM91.08,94.49h-32.16c-.53-9.65,7.16-16.38,15.94-15.32,8.79-1.17,16.71,5.57,16.22,15.32ZM92.17,83.02c-1.96-2.54-4.04-4.51-6.73-6.19,2.06-3.39,6-4.81,9.85-4.48,5.91-.36,10.89,3.71,10.74,10.61l-13.86.06Z"
      />
    </svg>
  );
}
